import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  BsThreeDotsVertical,
  BsBuilding,
  BsPlusCircleFill,
  BsCheckCircleFill,
  BsXCircleFill,
} from "react-icons/bs";
import { FaSchool, FaEdit } from "react-icons/fa";
import { MdCode } from "react-icons/md";
import { OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import api from "../../api/axiosInstance";
import CustomLoader from "../../Components/custom/CustomLoader";

const ListOperators = () => {
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);

  const getOperators = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Operators/GetOperators",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    api(config)
      .then(function (response) {
        setOperators(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getOperators();
  }, []);

  if (loading) {
    return (
      <div className="container-fluid mt-30">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <CustomLoader />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid mt-30">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h3 className="card-title d-flex align-items-center gap-2 mb-0">
              <BsBuilding size={24} />
              Operators
              <Badge
                bg="primary"
                style={{
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  backgroundColor: "var(--cts-primary)",
                }}
              >
                {operators.length}
              </Badge>
            </h3>
            {/* <Link
              to="/Settings/Operators/0"
              className="btn btn-sm btn-primary cts-btn-primary d-flex align-items-center gap-2"
            >
              <BsPlusCircleFill size={16} />
              Add Operator
            </Link> */}
          </div>
          <div className="card-body">
            {operators.length === 0 ? (
              <div className="text-center py-5">
                <BsBuilding size={48} className="text-muted mb-3" />
                <p className="text-muted">No operators found</p>
              </div>
            ) : (
              <div className="row g-4">
                {operators.map((operator) => (
                  <div
                    key={operator.operatorId}
                    className="col-12 col-md-6 col-lg-4 col-xl-3"
                  >
                    <div
                      className="card h-100 shadow-sm"
                      style={{
                        border: "1px solid #e0e0e0",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        position: "relative",
                        overflow: "hidden",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 16px rgba(0,0,0,0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 4px rgba(0,0,0,0.05)";
                      }}
                    >
                      {/* Status indicator bar */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          height: "4px",
                          backgroundColor: operator.isActive
                            ? "#28a745"
                            : "#dc3545",
                        }}
                      />

                      <div
                        className="card-body d-flex flex-column"
                        style={{ paddingTop: "1.25rem" }}
                      >
                        {/* Header with name and status */}
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div className="flex-grow-1">
                            <h5
                              className="card-title mb-2 d-flex align-items-center gap-2"
                              style={{ fontSize: "1.1rem", fontWeight: "600" }}
                            >
                              <BsBuilding
                                size={20}
                                style={{ color: "var(--cts-primary)" }}
                              />
                              {operator.operatorName}
                            </h5>
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <MdCode size={16} className="text-muted" />
                              <small className="text-muted">
                                {operator.operatorCode &&
                                operator.operatorCode.trim() !== ""
                                  ? operator.operatorCode
                                  : "No Code"}
                              </small>
                            </div>
                          </div>
                          {/* <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-status-${operator.operatorId}`}
                              >
                                {operator.isActive
                                  ? "Active Operator"
                                  : "Inactive Operator"}
                              </Tooltip>
                            }
                          >
                            <span>
                              {operator.isActive ? (
                                <BsCheckCircleFill
                                  size={20}
                                  style={{ color: "#28a745" }}
                                />
                              ) : (
                                <BsXCircleFill
                                  size={20}
                                  style={{ color: "#dc3545" }}
                                />
                              )}
                            </span>
                          </OverlayTrigger> */}
                        </div>

                        {/* Schools section */}
                        <div className="mb-3 flex-grow-1">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <small
                              className="text-muted d-flex align-items-center gap-1"
                              style={{
                                fontWeight: "600",
                                textTransform: "uppercase",
                                fontSize: "0.7rem",
                              }}
                            >
                              <FaSchool size={14} />
                              Schools
                            </small>
                            <Badge
                              bg="secondary"
                              style={{
                                fontSize: "0.65rem",
                                backgroundColor: "#6c757d",
                              }}
                            >
                              {operator.schools.length}
                            </Badge>
                          </div>
                          <div
                            style={{
                              maxHeight: "150px",
                              overflowY: "auto",
                              paddingRight: "8px",
                            }}
                            className="custom-scrollbar"
                          >
                            {operator.schools.length === 0 ? (
                              <p
                                className="text-muted mb-0"
                                style={{ fontSize: "0.85rem" }}
                              >
                                No schools assigned
                              </p>
                            ) : (
                              <ul className="list-unstyled mb-0">
                                {operator.schools.map((school, idx) => (
                                  <li
                                    key={idx}
                                    className="mb-2 d-flex align-items-start gap-2"
                                    style={{ fontSize: "0.85rem" }}
                                  >
                                    {/* <FaSchool
                                      size={12}
                                      className="mt-1"
                                      style={{
                                        color: "var(--cts-primary)",
                                        flexShrink: 0,
                                      }}
                                    /> */}
                                    <div className="flex-grow-1">
                                      <div style={{ fontWeight: "500" }}>
                                        {school.schoolName}
                                      </div>
                                      {school.schoolCode && (
                                        <small className="text-muted">
                                          Code: {school.schoolCode}
                                        </small>
                                      )}
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>

                        {/* Action button */}
                        <Link
                          to={`/Settings/Operators/${operator.operatorId}`}
                          className="btn btn-sm btn-outline-primary w-100 d-flex align-items-center justify-content-center gap-2"
                          style={{
                            borderColor: "var(--cts-primary)",
                            color: "var(--cts-primary)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "var(--cts-primary)";
                            e.currentTarget.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                            e.currentTarget.style.color = "var(--cts-primary)";
                          }}
                        >
                          <FaEdit size={14} />
                          Manage Operator
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
    </>
  );
};

export default ListOperators;
